export default __webpack_public_path__ + "static/media/card3.53b83028.png";